module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "main-text_H1-CHAPTER-HEAD",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_vm._v("Voices in the Dark")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_text-no-indent"
  }, [_vm._v("My sleep’s usually riddled with nightmares. Flashes of babies crying, strangers running from monsters, never-ending stone corridors, and a blinding white light. Most of the time it’s just me, drowning in a faraway sea. No wonder Violet thinks I’m scared of the dark. I always wake up screaming, twisted in my sweaty sheets. This, though—actually being knocked unconscious—ain’t too shabby at all, like being wrapped in a thick, warm blanket. A floating cocoon where no bad dream can touch you. A safe place, deeper than normal sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("Only problem is you have to wake up.")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“I was surprised to get your message.” A deep voice tugs at my ears. “Capturing her after all these years. Throwing her inside this thing. Quite the change of character, Robin.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“Perhaps.” An old and scratchy voice. "), _c('span', {
    staticClass: "main-text_CMS-ital"
  }, [_vm._v("Her")]), _vm._v(" voice. “But I have my reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“So you keep saying. You have not, however, told me what those reasons are. Nothing is ever this simple with you. You haven’t set foot on a boat in years. How did you know she was going to end up in the water? You cannot tell me it was mere coincidence.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“Of course it was no coincidence. There is no such thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“Then how—”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“You have waited fourteen years for this moment, Eric. I am surprised you are asking any questions at all. I have handed over the girl. She is no longer under my protection.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("A moment of silence.")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“You know what this means, Robin. What you’re giving me permission to do. You may have struck a deal with my predecessor, but I won’t stand for it. Breaking curfew, wandering the streets, knocking on my door, bold as brass. Attacking an innocent group of people—attacking my own "), _c('span', {
    staticClass: "main-text_CMS-ital"
  }, [_vm._v("son")]), _vm._v(". And another quake—today of all days—hours before the Lament? They’re getting worse. We all know it. We cannot live like this. We won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“Like I said, I can protect her no more.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“And what of the other?”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“His time will come soon enough. Leave him be. Now, if you please, Ms. Doe is about to wake up. I would like a quick word with her alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“You think you can tell "), _c('span', {
    staticClass: "main-text_CMS-ital"
  }, [_vm._v("me")]), _vm._v("—”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "main-text_CMS-ital"
  }, [_vm._v("know")]), _vm._v(" I can tell you, Eric. Out. Don’t even think about listening at the door. After I am through with Jane you may do what you wish, but until then I want absolute privacy.”")]), _vm._v(" "), _c('p', {
    staticClass: "main-text_TEXT"
  }, [_vm._v("I don’t like the sound of this, but she’s right about one thing. My cocoon’s unravelling, slowly spinning me through the dark. A door slams shut. My eyes blink open. Shapes blur, senses sharpen. It’s time to face the waking world again, whether I like it or not.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2392e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/x9781541541771-9.vue
// module id = 87
// module chunks = 0